<template>
	<span class="phone">
		{{ formattedTel }}
	</span>
</template>
<script>
	export default {
		name: 'PhoneNumber',
		props: {
			tel: {
				type: [String, Number],
				default: '',
			},
		},
		computed: {
			formattedTel() {
				if (this.tel) {
					const tel =
						typeof this.tel === 'number'
							? this.tel.toString()
							: this.tel;

					if (tel.length === 10) {
						const match = tel.match(/^(\d{3})(\d{3})(\d{4})$/);
						return `${match[1]}-${match[2]}-${match[3]}`;
					} else if (tel.length === 11) {
						const match = tel.match(/^(\d{3})(\d{4})(\d{4})$/);
						return `${match[1]}-${match[2]}-${match[3]}`;
					} else {
						return tel;
					}
				} else {
					return '';
				}
			},
		},
	};
</script>
